<template>
  <div
    :class="$style.root"
  >
    <shared-education-categories-component
      :data="data"
      :on-edition-page="true"
    />

    <pages-editions-slug-education-modal-component
      v-if="route?.query?.educationSlug"
    />
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})
</script>

<style module>
.root {
  composes: container from global;

  display: flex;
  flex-direction: column;
  gap: var(--font-small--line-height);

  margin-top: var(--font-small--line-height);
}
</style>
